import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { Box, TextField } from '@mui/material';
// import CKEditor from "ckeditor4-react";
import { Downgraded, useState } from '@hookstate/core';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import TinyMCEEditor from '../../sharedcomponents/tinymceEditor/tinymce';
const AddNotes = (props) => {
    console.log(props);

    const message = useState();
    const userInfo = useState(null);
    const eventData = useState(null);
    const title = useState();
    const [disableBtn, setDisableBtn] = React.useState(true);
    useEffect(() => {
        const guserInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        userInfo.set(guserInfo);
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }
        if (props.notesInfo != undefined) {
            message.set(props.notesInfo.notesText);
            title.set(props.notesInfo.title);
        } else {
            message.set(null);
            title.set(null);
        }
    }, []);

    const setEditorValue = (value) => {
        message.set(value);
        handleDisableBtn();
    }
    const renderDialogContent = () => {
        return (
            <>
                <Box
                    component="form"
                    sx={{
                        width: '100%',
                    }}>
                    <TextField
                        fullWidth
                        sx={{
                            marginRight: 2,
                            marginBottom: 2,
                        }}
                        size="small"
                        value={title.get()}
                        onChange={(e) => {
                            title.set(e.target.value);
                            handleDisableBtn();
                        }}
                        id="outlined-required"
                        label="Title"
                    />

                    <Box
                        sx={{
                            flex: 1,
                            flexDirection: 'row',
                            marginTop: 1,
                            width: { xs: '100%', md: '100%' },
                        }}>
                        {/* <CKEditor
                        sx={{
                            marginTop: 2,
                            marginRight: 2,
                        }}
                        data={message.get()}
                        onChange={(event) =>
                            message.set(event.editor.getData())
                        }
                        config={{
                            removeButtons: 'Subscript,Superscript',
                            extraAllowedContent: '*{*};*(*);span{!color}'
                        }}
                    /> */}
                        <TinyMCEEditor
                            value={message.get()}
                            setValue={setEditorValue}
                            enableImageEncode
                        />
                        {/* <CKEditor
                            sx={{
                                marginTop: 2,
                                marginRight: 2,
                            }}
                            editor={Editor}
                            config={{
                                image: {
                                    upload: [
                                        'jpeg',
                                        'png',
                                        'gif',
                                        'bmp',
                                        'webp',
                                        'tiff',
                                    ],
                                },
                                removeButtons: 'Subscript,Superscript',
                                extraAllowedContent: '*{*};*(*);span{!color}',
                            }}
                            data={message.get()}
                            onChange={(event, editor) => {
                                message.set(editor.getData());
                                handleDisableBtn();
                            }}
                        /> */}
                    </Box>
                </Box>
            </>
        );
    };
    const renderDialogActions = () => {
        return (
            <ButtonContainer
                showLoading={true}
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={props.notesInfo ? 'Update' : 'Create'}
                disableUpdateButton={props.notesInfo ? disableBtn : false}
            />
        );
    };

    const handleDisableBtn = () => {
        if (props.notesInfo != undefined) {
            const data = props.notesInfo;
            let prevData = {
                title: data.title,
                message: data.notesText,
            };

            let currentData = {
                title: title.attach(Downgraded).get(),
                message:
                    message.attach(Downgraded).get() === ''
                        ? null
                        : message.attach(Downgraded).get(),
            };
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true);
            } else {
                setDisableBtn(false);
            }
        }
    };

    const handleClick = () => {
        if (
            (message.get() && message.get() !== '') ||
            (title.get() && title.get() !== '')
        ) {
            const payLoad = {
                notesID: props.notesInfo ? props.notesInfo.notesID : 0,
                title: title.get(),
                eventID: eventData.get().eventID,
                notesText: message.get() ? encodeURIComponent(message.get()) : '',
                createdBy: userInfo.get().userID,
                modifiedBy: userInfo.get().userID,
                notesStatus: 1,
            };
            ApiHelper.post(APIURLConstants.POST_NOTES, payLoad).then((res) => {
                if (res.status == 200) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: props.notesInfo
                            ? 'Notes updated successfully'
                            : 'Notes added Successfully.',
                    });
                    props.handleClose();
                    props.getNotes();
                } else {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while adding a notes.',
                    });
                }
            });
        } else {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please add title Or body',
            });
        }
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            disableEnforceFocus={true}
        />
    );
};
export default AddNotes;
